import React, { useState, useContext } from 'react';
import { SignUpOLB, SendFactorForSignUp, VerifyPasscodeForSignUp, RegisterOLB, SignIn } from 'api';
import { FindMemberForm, FactorSelectionForm, VerifyPasscodeForm } from 'forms';
import { Process, Success } from 'common';
import { SignInContext } from 'contexts';
import { navigate, useQueryParams } from 'hookrouter';
import { useApi } from 'hooks';
import { writToStore } from 'storage';
import MemberSignUpForm from '../../../forms/memberSignUpForm';

const FindMemberPage = () => {
  const [queryParams] = useQueryParams();
  const [step, setStep] = useState(1);
  const [member, setMember] = useState();
  const [factors, setFactors] = useState();
  const [stateToken, setStateToken] = useState();
  const [selectedFactor, setSelectedFactor] = useState();

  const [signUpStatus, callSignUpOLB] = useApi(SignUpOLB);
  const [signInStatus, callSignIn] = useApi(SignIn);
  const [sendStatus, callSendFactor] = useApi(SendFactorForSignUp);
  const [verifyStatus, callVerifyPasscode] = useApi(VerifyPasscodeForSignUp);
  const [registerStatus, callRegisterOLB] = useApi(RegisterOLB);
  const [, setSignInContext] = useContext(SignInContext);

  const findMember = (accountNumber, ssn) => {
    // MAX: Todo get user info
    callSignUpOLB(accountNumber, ssn).then((data) => {
      if (data?.factor) {
        setMember({ accountNumber, ssn });
        setFactors(data.factor);
        setStateToken(data.stateToken);
        setStep(2);
      }
    });
  };

  const send = (factor) => {
    setSelectedFactor(factor);
    callSendFactor(stateToken, factor).then((data) => {
      if (data) {
        setStateToken(data.stateToken);
        setStep(3);
      }
    });
  };

  const verify = async (passcode) => {
    await callVerifyPasscode(stateToken, selectedFactor, passcode).then((data) => {
      if (data) {
        setStateToken(data.sessionToken);
        setStep(4);
      }
    });
  };

  const register = (login, password, reenter) => {
    callRegisterOLB(stateToken, login, password, reenter, true).then((data) => data && signIn(login, password));
  }

  const signIn = async (username, password) => {
    writToStore('login', username);
    const signInResponse = await callSignIn(username, password);
    if (signInResponse) {
      const { AccessToken, Factor, StateToken, Status: loginStatus } = signInResponse;
      switch (loginStatus) {
        case 'SUCCESS':
          onSuccess(AccessToken);
          break;
        default:
          setStep(5);
          break;
      }
    }
  };

  const onSuccess = (accessToken) => {
    setSignInContext(accessToken);
    navigate('/mortgage/sign-in/post-processing', true, { appId: 'Mortgage', ...queryParams });
  };

  const isLoading = () => signUpStatus.isLoading || sendStatus.isLoading || verifyStatus.isLoading || registerStatus.isLoading || signInStatus.isLoading; 

  const error = () => {
    let tempError = false;
    if (signUpStatus.error) tempError = signUpStatus.error;
    if (sendStatus.error) tempError = sendStatus.error;
    if (verifyStatus.error) tempError = verifyStatus.error;
    if (registerStatus.error) tempError = registerStatus.error;
    if (signInStatus.error) tempError = signInStatus.error;
    return tempError;
  };
  // MAX: TODO -> Next step should go to the new sign up page
  return (
    <Process error={error} isLoading={isLoading}>
      {step === 1 && <FindMemberForm forgot={findMember} />}
      {step === 2 && <FactorSelectionForm factors={factors} send={send} />}
      {step === 3 && (
        <VerifyPasscodeForm verify={verify} selectedFactor={selectedFactor} resend={() => send(selectedFactor)} />
      )}
      {step === 4 && <MemberSignUpForm signUp={register}/>}
      {step === 5 && (
        <Success header={'Your registration is complete. Click here to sign in.'} href={'/mortgage/sign-in'} />
      )}
    </Process>
  );
};

export default FindMemberPage;
